import { createContext } from 'react';
import { ICategory } from '../../shared-interfaces/Notation/ICategory';
import { IEncouragementType } from '../../shared-interfaces/Notation/IEncouragementType';
import { IReason } from '../../shared-interfaces/Notation/IReason';

interface ICustomWindow extends Window {
  initialAppState?: any;
}

interface INotationAttributesContext {
  categories: ICategory[];
  reasons: IReason[];
  encouragementTypes: IEncouragementType[];
  assessmentFerpaStatement: string;

}

const customWindow: ICustomWindow = window;

const NotationAttributeContext = createContext(
  customWindow.initialAppState.notationAttributes as INotationAttributesContext,
);

export default NotationAttributeContext;
